import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

export const RESCUE_CHANGED = "lead-rescue-changed";
export const rescueChanged = () => window.dispatchEvent(new Event(RESCUE_CHANGED));

// Leads from this morning's 9am check that are still held back (sidebar badge).
export function useRescueCount(enabled) {
  const [count, setCount] = useState(0);
  const { pathname } = useLocation();
  useEffect(() => {
    if (!enabled) return undefined;
    let live = true;
    const load = () => api.get("/admin/lead-rescue/alert")
      .then((r) => { if (live) setCount(r.data.alert?.waiting || 0); })
      .catch(() => {});
    load();
    const timer = setInterval(load, 60000);
    window.addEventListener(RESCUE_CHANGED, load);
    return () => {
      live = false;
      clearInterval(timer);
      window.removeEventListener(RESCUE_CHANGED, load);
    };
  }, [enabled, pathname]);
  return count;
}
